import React, { useEffect, useState } from "react";
import {
  getSmsTemplates,
  saveSmsTemplate,
  toggleSmsTemplate,
} from "../../services/api";
import toast from "react-hot-toast";
import "./templates.css";

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [message, setMessage] = useState("");
  const [contributionType, setContributionType] = useState("");
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const res = await getSmsTemplates();
      setTemplates(res.data || []);
    } catch {
      toast.error("Failed to load templates");
    }
  };

  const save = async () => {
    if (!message || !contributionType) {
      toast.error("Fill all fields");
      return;
    }

    try {
      setLoading(true);

      await saveSmsTemplate({
        contribution_type: contributionType,
        event_type: "CONTRIBUTION_RECEIVED",
        message_template: message,
        language: "SW",
      });

      toast.success(
        editingId
          ? "Template updated successfully"
          : "Template saved successfully"
      );

      setMessage("");
      setContributionType("");
      setEditingId(null);

      load();
    } catch {
      toast.error("Failed to save template");
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async (id) => {
    try {
      await toggleSmsTemplate(id);

      toast.success("Template status updated");

      load();
    } catch {
      toast.error("Failed to update template");
    }
  };

  const editTemplate = (template) => {
    setEditingId(template.template_id);

    setContributionType(
      template.contribution_type
    );

    setMessage(
      template.message_template
    );

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="sms-template-page">

      {/* HEADER */}

      <div className="template-header">

        <div>
          <h2>SMS Templates</h2>

          <p>
            Configure SMS notifications
            for church contributions.
          </p>
        </div>

        <div className="template-count-card">
          <span>Total Templates</span>
          <strong>
            {templates.length}
          </strong>
        </div>

      </div>

      {/* FORM CARD */}

      <div className="template-form-card">

        <div className="form-title">
          {editingId
            ? "Edit Template"
            : "Create New Template"}
        </div>

        <input
          className="input"
          placeholder="Contribution Type (e.g TITHE)"
          value={contributionType}
          onChange={(e) =>
            setContributionType(
              e.target.value
            )
          }
        />

        <textarea
          className="input"
          rows={6}
          placeholder={`Hello {NAME},

Your contribution of TZS {AMOUNT}
for {TYPE} has been received.

Transaction ID: {TRANSACTION_ID}

Member Code: {MEMBER_CODE}

Thank you - ZAKA PAY`}
          value={message}
          onChange={(e) =>
            setMessage(
              e.target.value
            )
          }
        />

        <div className="template-helper">

          <h4>
            Available Variables
          </h4>

          <div className="variable-tags">

            <span>{`{NAME}`}</span>
            <span>{`{AMOUNT}`}</span>
            <span>{`{TYPE}`}</span>
            <span>{`{TRANSACTION_ID}`}</span>
            <span>{`{MEMBER_CODE}`}</span>
            <span>{`{PAROKIA}`}</span>

          </div>

        </div>

        <div
          style={{
            marginTop: 20,
            display: "flex",
            gap: 10,
          }}
        >

          <button
            className="btn-purple"
            onClick={save}
            disabled={loading}
          >
            {loading
              ? "Saving..."
              : editingId
              ? "Update Template"
              : "Save Template"}
          </button>

          {editingId && (
            <button
              className="btn-purple-outline"
              onClick={() => {
                setEditingId(null);
                setMessage("");
                setContributionType("");
              }}
            >
              Cancel Edit
            </button>
          )}

        </div>

      </div>

      {/* LIST HEADER */}

      <div className="template-list-header">

        <h3>
          Existing Templates
        </h3>

        <span>
          Manage active and inactive
          SMS templates
        </span>

      </div>

      {/* TABLE */}

      <div className="template-table-card">

        <table className="table">

          <thead>
            <tr>
              <th>Contribution</th>
              <th>Message</th>
              <th>Status</th>
              <th width="220">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>

            {templates.length === 0 ? (
              <tr>
                <td
                  colSpan="4"
                  style={{
                    textAlign:
                      "center",
                  }}
                >
                  No templates found
                </td>
              </tr>
            ) : (
              templates.map((t) => (
                <tr
                  key={t.template_id}
                >
                  <td>
                    <strong>
                      {
                        t.contribution_type
                      }
                    </strong>
                  </td>

                  <td>
                    <div
                      style={{
                        maxWidth:
                          "550px",
                        whiteSpace:
                          "nowrap",
                        overflow:
                          "hidden",
                        textOverflow:
                          "ellipsis",
                      }}
                    >
                      {
                        t.message_template
                      }
                    </div>
                  </td>

                  <td>

                    <span
                      className={
                        t.is_active
                          ? "status-active"
                          : "status-inactive"
                      }
                    >
                      {t.is_active
                        ? "ACTIVE"
                        : "INACTIVE"}
                    </span>

                  </td>

                  <td>

                    <button
                      className="btn-purple-outline"
                      onClick={() =>
                        editTemplate(
                          t
                        )
                      }
                    >
                      Edit
                    </button>

                    <button
                      style={{
                        marginLeft: 8,
                      }}
                      className={
                        t.is_active
                          ? "btn-danger-outline"
                          : "btn-purple"
                      }
                      onClick={() =>
                        toggleStatus(
                          t.template_id
                        )
                      }
                    >
                      {t.is_active
                        ? "Deactivate"
                        : "Activate"}
                    </button>

                  </td>

                </tr>
              ))
            )}

          </tbody>

        </table>

      </div>

    </div>
  );
}